import { Component, Inject, Optional, OnInit,ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material/chips';
import { MatTable } from '@angular/material/table';
import { FactorPonderacion } from 'app/main/models/factor-ponderacion.model';
import { Ponderacion } from 'app/main/models/ponderacion.model';
import {MatIconModule} from '@angular/material/icon';
import {TranslateService} from '@ngx-translate/core';


const ELEMENT_DATA: Ponderacion[] = [];

@Component({
  selector: 'app-dialog-box',
  templateUrl: './dialog-box.component.html',
  styleUrls: ['./dialog-box.component.scss']
})
export class DialogBoxComponent {

  action: string;
  LOCAL_DATA: any;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  new_line:Ponderacion = {id:null,descripcion:'',porcentaje:0,factor:0,new:true};

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  tiposEvaluacion = [];

  displayedColumns: string[] = ['descripcion','porcentaje','factor','action'];
  dataSource = ELEMENT_DATA;
  @ViewChild(MatTable, {static: true}) table: MatTable<any>;

  constructor(
    public dialogRef: MatDialogRef<DialogBoxComponent>,
    public translate: TranslateService,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: FactorPonderacion) {
    console.log(data);
    this.LOCAL_DATA = {...data};
    this.dataSource = data.ponderaciones || [];
    this.dataSource.sort((a, b) => (a.porcentaje > b.porcentaje) ? 1 : -1);
    this.action = this.LOCAL_DATA.action;

    if(this.action=='Duplicate')
      this.LOCAL_DATA = new FactorPonderacion(this.LOCAL_DATA);

  }

  doAction(): void{
    console.log('im here');
    this.LOCAL_DATA.ponderaciones = this.dataSource;
    this.dialogRef.close({event: this.action, data: this.LOCAL_DATA});
  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }


  remove(ponderacion: any): void {
    var index = -1;

    for(var i=0; this.dataSource.length>i;i++){
      if((ponderacion.id!=null &&  this.dataSource[i].id !=null &&
            ponderacion.descripcion== this.dataSource[i].descripcion) ||
          (ponderacion.descripcion == this.dataSource[i].descripcion)){
        index = i;
        break;
      }
    }

    if (index >= 0) {
      this.dataSource.splice(index, 1);
    }

    this.dataSource = [...this.dataSource];
  }

  addLine():void{

    if(this.dataSource == undefined){
      this.dataSource = [];
    }


    // Add our fruit
    this.new_line.factor = this.new_line.porcentaje/100;
    if(this.new_line.new)
      this.dataSource.push(this.new_line);

    //this.table.renderRows();
    this.dataSource.sort((a, b) => (a.porcentaje > b.porcentaje) ? 1 : -1);
    this.dataSource = [...this.dataSource];
    this.new_line = {id:null,descripcion:'',porcentaje:0,factor:0,new:true};
  }

  edit(ponderacion: any):void{
    // Add our fruit
    this.new_line = ponderacion;
    this.new_line.new = false
    //{id:ponderacion.id,descripcion:ponderacion.descripcion,porcentaje:ponderacion.porcentaje,factor:ponderacion.factor};
  }

  ngOnInit(): void {

  }

}
